export type ArgRef =
  | { from: 'exp' | 'cfg' | 'local'; path: string }
  | { literal: unknown };

export type EventSpec = {
  name: string;
  args?: ArgRef[];
};

export type TriggerCtx = {
  exp?: any;
  cfg?: any;
  local?: any;
};

function getByPath(obj: any, path: string) {
  if (!obj || !path) return undefined;
  // jednostavan path resolver: foo.bar[0].baz
  return path
    .replace(/\[(\d+)\]/g, '.$1')
    .split('.')
    .filter(Boolean)
    .reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

function materializeArg(ref: ArgRef, ctx: TriggerCtx) {
  if ('literal' in ref) return ref.literal;
  const source =
    ref.from === 'exp'
      ? ctx.exp
      : ref.from === 'cfg'
        ? ctx.cfg
        : ref.from === 'local'
          ? ctx.local
          : undefined;
  return getByPath(source, ref.path);
}

export function createEventTrigger(exp?: any) {
  const hub = exp?.eventHub ?? exp?.eh ?? null;

  return function trigger(spec?: EventSpec, ctx?: TriggerCtx) {
    if (!spec?.name) {
      console.warn('[event] no spec/name provided', spec);
      return;
    }

    const args = (spec.args ?? []).map((a) => materializeArg(a, ctx ?? {}));
    if (hub?.emit) {
      hub.emit(spec.name, ...args);
      console.log(`[event] emit "${spec.name}"`, args);
    } else if (hub?.trigger) {
      hub.trigger(spec.name, ...args);
      console.log(`[event] trigger "${spec.name}"`, args);
    } else {
      console.log(`[event] (no hub) "${spec.name}"`, args);
    }
  };
}
